import React, { FC, Fragment, useEffect, useState } from 'react'
import { Paper, Tabs, makeStyles, Tab, Hidden, Container } from '@material-ui/core'
import Business from '@material-ui/icons/Business'
import PeopleAlt from '@material-ui/icons/PeopleAlt'
import IconSync from '@material-ui/icons/Sync'
import { useHistory, useLocation } from 'react-router-dom'
import { Redirect, Route, Switch } from 'react-router-dom'
import Customers from './customers'
import Users from './users'
import { RouteCustomerProps } from '../../routes/customermanagement'
import TerminalChanges from './terminalchanges'

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
        //maxWidth: 500,
    },
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        // marginLeft: "-24px",
    },
    button: {
        minWidth: "unset",
    }
})

const InternalNavigation: FC = () => {
    const classes = useStyles()
    const history = useHistory()
    const routeCustomer = useLocation<RouteCustomerProps>()
    const {page} = (routeCustomer.state) ? routeCustomer.state : new RouteCustomerProps()
    const [currentPage, setCurrentPage] = useState(-1)

    useEffect(() => {
        if (currentPage === -1 || currentPage !== page) {
            const {page} = (routeCustomer.state) ? routeCustomer.state : new RouteCustomerProps()
            setCurrentPage(page)
        }
    }, [currentPage, page, routeCustomer.state])

    const changePage = (historyState: RouteCustomerProps) => {
        setCurrentPage(historyState.page)

        switch (historyState.page) {
        case 0: // Customers
            history.push('/customermanagement/customers', historyState)
            break
        case 1: // Users
            history.push('/customermanagement/users', historyState)
            break
        case 2: // Terminal changes
            history.push('/customermanagement/terminalchanges', historyState)
            break;
        default:
            break
        }
    }
    const handleChange = (_: React.ChangeEvent<{}> | null, newValue: number) => {
        changePage(new RouteCustomerProps(newValue))
    }

    return (
        <Fragment>
            <Hidden smDown>
                <Container>
                    <Paper square className={classes.root}>
                        <Tabs value={currentPage} onChange={handleChange} variant="fullWidth" indicatorColor="primary" textColor="primary" aria-label="icon label tabs example">
                            <Tab icon={<Business />} label="Kunder" />
                            <Tab icon={<PeopleAlt />} label="Brugere" />
                            <Tab icon={<IconSync />} label="Automat ændringer" />
                        </Tabs>
                    </Paper>
                </Container>
            </Hidden>
            <Switch>
                <Route exact path={`/customermanagement`}>
                    <Redirect to={`/customermanagement/customers`}/>
                </Route>
                <Route path={`/customermanagement/customers`}>
                    <Customers/>
                </Route>
                <Route path={`/customermanagement/users`}>
                    <Users/>
                </Route>
                <Route path={`/customermanagement/terminalchanges`}>
                    <TerminalChanges/>
                </Route>
                <Route> <div>Siden bliv ikke fundet</div></Route>
            </Switch>
        </Fragment>
    )
}

export default InternalNavigation
